module.exports = __webpack_public_path__ + "static/media/fist.fdcc7814.jpg";